module.exports = __webpack_public_path__ + "static/media/data-visualization.facac88b.jpg";